<template>
	<div>
		<div class="relative mt-6">
			<div class="absolute inset-0 flex items-center" aria-hidden="true">
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="
						bg-body
						px-2
						text-neutral-600
						font-semibold
						whitespace-nowrap
						flex flex-nowrap
						items-center
						text-2xl
						justify-center
						gap-6
					"
				>
					<div
						class="cursor-pointer"
						@click="prevDay"
						v-if="date.month > 0 || date.year > 2023"
					>
						<svg
							width="8"
							height="12"
							viewBox="0 0 8 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6.5 1L1.5 6L6.5 11"
								stroke="#48566A"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
					<VueDatepicker
						class="input-date-dashboard"
						placeholder="Chọn tháng"
						uid="filter-by-date"
						v-model="date"
						auto-apply
						month-picker
						format="MM/yyyy"
						:min-date="new Date(2023, 1, 0)"
						:max-date="new Date()"
					>
						<template #trigger>
							<div
								v-if="date"
								class="flex items-center gap-2.5 cursor-pointer"
							>
								<svg
									width="17"
									height="16"
									viewBox="0 0 17 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M4.5 0.5C4.5 0.223858 4.27614 0 4 0C3.72386 0 3.5 0.223858 3.5 0.5V1H2.5C1.39543 1 0.5 1.89543 0.5 3V4H16.5V3C16.5 1.89543 15.6046 1 14.5 1H13.5V0.5C13.5 0.223858 13.2761 0 13 0C12.7239 0 12.5 0.223858 12.5 0.5V1H4.5V0.5ZM16.5 14V5H0.5V14C0.5 15.1046 1.39543 16 2.5 16H14.5C15.6046 16 16.5 15.1046 16.5 14ZM10 7C9.72386 7 9.5 7.22386 9.5 7.5V8.5C9.5 8.77614 9.72386 9 10 9H11C11.2761 9 11.5 8.77614 11.5 8.5V7.5C11.5 7.22386 11.2761 7 11 7H10ZM13 7C12.7239 7 12.5 7.22386 12.5 7.5V8.5C12.5 8.77614 12.7239 9 13 9H14C14.2761 9 14.5 8.77614 14.5 8.5V7.5C14.5 7.22386 14.2761 7 14 7H13ZM2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.27614 10 4.5 10.2239 4.5 10.5V11.5C4.5 11.7761 4.27614 12 4 12H3C2.72386 12 2.5 11.7761 2.5 11.5V10.5ZM6 10C5.72386 10 5.5 10.2239 5.5 10.5V11.5C5.5 11.7761 5.72386 12 6 12H7C7.27614 12 7.5 11.7761 7.5 11.5V10.5C7.5 10.2239 7.27614 10 7 10H6Z"
										fill="#48566A"
									/>
								</svg>
								<span>Tháng {{ dateTitle }}</span>
							</div>
						</template>
					</VueDatepicker>
					<div
						class="cursor-pointer"
						@click="nextDay"
						v-if="
							date.month < new Date().getMonth() ||
							date.year < new Date().getFullYear()
						"
					>
						<svg
							width="8"
							height="12"
							viewBox="0 0 8 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.5 11L6.5 6L1.5 1"
								stroke="#48566A"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">Kết quả học tập</div>
			<div
				class="
					grid grid-cols-3
					items-stretch
					md-down:grid-cols-1
					mt-2
					gap-4
				"
			>
				<div
					class="
						bg-white
						shadow-sm
						rounded-2xl
						overflow-hidden
						flex flex-col
						justify-center
						items-center
						py-6
						w-full
					"
				>
					<div class="text-neutral-600 font-bold text-lg">
						Hoàn thành mục tiêu
					</div>
					<apexchart
						type="radialBar"
						height="240"
						:options="chartOptions2_1"
						:series="[
							data.assessment_stats.average_result_in_percent ||
								0,
						]"
					></apexchart>
					<div
						v-show="
							+data.assessment_stats
								.compare_last_average_result !== 0
						"
						class="
							grow-value
							flex flex-nowrap
							rounded-lg
							py-1
							px-2
							items-center
							w-fit
						"
						:class="
							data.assessment_stats.compare_last_average_result >=
							0
								? 'bg-green-50 text-green-400'
								: 'bg-sienna-50 text-sienna-400'
						"
					>
						<svg
							width="10"
							height="12"
							viewBox="0 0 10 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							:class="{
								'transform rotate-180':
									data.assessment_stats
										.compare_last_average_result >= 0,
							}"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
								fill="currentColor"
							/>
						</svg>
						<div class="ml-2 font-bold text-sm text-neutral-700">
							{{
								Math.abs(
									Math.round(
										data.assessment_stats
											.compare_last_average_result * 10
									) / 10
								)
							}}%
						</div>
					</div>
				</div>
				<div
					class="
						bg-white
						shadow-sm
						rounded-2xl
						overflow-hidden
						flex flex-col
						justify-center
						items-center
						py-6
					"
				>
					<div class="text-neutral-600 font-bold text-lg">
						Sự tham gia của trẻ
					</div>
					<apexchart
						type="radialBar"
						height="240"
						:options="chartOptions2_2"
						:series="[
							data.assessment_stats
								.average_cooperation_scale_in_percent || 0,
						]"
					></apexchart>
					<div
						v-show="
							+data.assessment_stats
								.compare_last_average_cooperation_scale !== 0
						"
						class="
							grow-value
							flex flex-nowrap
							rounded-lg
							py-1
							px-2
							items-center
							w-fit
						"
						:class="
							+data.assessment_stats
								.compare_last_average_cooperation_scale >= 0
								? 'bg-green-50 text-green-400'
								: 'bg-sienna-50 text-sienna-400'
						"
					>
						<svg
							width="10"
							height="12"
							viewBox="0 0 10 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							:class="{
								'transform rotate-180':
									+data.assessment_stats
										.compare_last_average_cooperation_scale >=
									0,
							}"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
								fill="currentColor"
							/>
						</svg>
						<div class="ml-2 font-bold text-sm text-neutral-700">
							{{
								Math.abs(
									Math.round(
										+data.assessment_stats
											.compare_last_average_cooperation_scale *
											10
									) / 10
								)
							}}%
						</div>
					</div>
				</div>
				<div
					class="
						bg-white
						shadow-sm
						rounded-2xl
						overflow-hidden
						flex flex-col
						justify-center
						items-center
						py-6
					"
				>
					<div class="text-neutral-600 font-bold text-lg">
						Cảm xúc
					</div>
					<apexchart
						type="radialBar"
						height="240"
						:options="chartOptions2_3"
						:series="[
							data.assessment_stats
								.average_emotion_scale_in_percent || 0,
						]"
					></apexchart>
					<div
						v-show="
							+data.assessment_stats
								.compare_last_average_emotion_scale !== 0
						"
						class="
							grow-value
							flex flex-nowrap
							rounded-lg
							py-1
							px-2
							items-center
							w-fit
						"
						:class="
							+data.assessment_stats
								.compare_last_average_emotion_scale >= 0
								? 'bg-green-50 text-green-400'
								: 'bg-sienna-50 text-sienna-400'
						"
					>
						<svg
							width="10"
							height="12"
							viewBox="0 0 10 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							:class="{
								'transform rotate-180':
									+data.assessment_stats
										.compare_last_average_emotion_scale >=
									0,
							}"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
								fill="currentColor"
							/>
						</svg>
						<div class="ml-2 font-bold text-sm text-neutral-700">
							{{
								Math.abs(
									Math.round(
										+data.assessment_stats
											.compare_last_average_emotion_scale *
											10
									) / 10
								)
							}}%
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">
				Thống kê học can thiệp
			</div>
			<div
				class="
					grid grid-cols-1
					md:grid-cols-3
					lg:grid-cols-5
					w-full
					gap-4
					mt-2
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/clock.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px; min-width: 23px"
							/>
						</div>
						<div>Giờ đã học/giờ dự kiến</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.session_stats?.total_non_cancelled_hours }}/{{
							data?.session_stats?.total_hours
						}}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/clock.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px; min-width: 23px"
							/>
						</div>
						<div>Giờ học phát sinh</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.session_stats?.total_unscheduled_hours }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/clock.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px; min-width: 23px"
							/>
						</div>
						<div>Giờ chưa học</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.session_stats?.incompleted_hours }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/clock.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px; min-width: 23px"
							/>
						</div>
						<div>Giờ xin nghỉ</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.session_stats?.total_cancelled_hours }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/user.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px; min-width: 32px"
							/>
						</div>
						<div>Giáo viên dạy</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.session_stats?.staffs_count }}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10" v-if="student.has_day_care_class">
			<div class="font-semibold text-neutral-500">
				Thống kê học bán trú
			</div>
			<div
				class="
					grid grid-cols-1
					md:grid-cols-2
					lg:grid-cols-4
					w-full
					gap-4
					mt-2
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/schedule.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Ngày đã học</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.class_session_stats?.finished_count }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/schedule.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Ngày học cố định</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.class_session_stats?.scheduled_count }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/schedule.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Ngày học phát sinh</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.class_session_stats?.unscheduled_count }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/schedule.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Ngày xin nghỉ</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data?.class_session_stats?.cancelled_count }}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">Hình ảnh/ Video</div>
			<div
				class="
					grid grid-cols-2
					items-start
					md-down:grid-cols-1
					mt-2
					gap-4
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="21"
								height="20"
								viewBox="0 0 21 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M17.5019 2.5H2.50192C1.81157 2.5 1.25192 3.05964 1.25192 3.75V15L4.55998 12.0581C4.77065 11.8474 5.10072 11.8147 5.34861 11.98L8.67229 14.1958L13.31 9.55807C13.5002 9.36785 13.7908 9.32069 14.0314 9.441L18.7519 11.875V3.75C18.7519 3.05964 18.1923 2.5 17.5019 2.5ZM2.50192 1.25C1.12121 1.25 0.00192261 2.36929 0.00192261 3.75V16.25C0.00192261 17.6307 1.12121 18.75 2.50192 18.75H17.5019C18.8826 18.75 20.0019 17.6307 20.0019 16.25V3.75C20.0019 2.36929 18.8826 1.25 17.5019 1.25H2.50192ZM7.50192 6.875C7.50192 7.91053 6.66246 8.75 5.62692 8.75C4.59139 8.75 3.75192 7.91053 3.75192 6.875C3.75192 5.83947 4.59139 5 5.62692 5C6.66246 5 7.50192 5.83947 7.50192 6.875Z"
									fill="#F0BB4F"
								/>
							</svg>
						</div>
						<div>Số lượng hình ảnh</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.goal_media_stats.image_count }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clip-path="url(#clip0_16570_9419)">
									<path
										d="M18.0542 2.5H1.94598C1.69039 2.49995 1.4373 2.55273 1.20115 2.65531C0.965002 2.7579 0.750429 2.90829 0.569684 3.09789C0.388939 3.28749 0.245562 3.51259 0.147741 3.76034C0.0499209 4.00808 -0.000426956 4.27362 -0.000426952 4.54178V15.4582C-0.000567593 15.7265 0.0496765 15.9921 0.147434 16.24C0.245192 16.4879 0.388546 16.7131 0.569305 16.9028C0.750065 17.0926 0.964685 17.243 1.2009 17.3457C1.43712 17.4484 1.6903 17.5012 1.94598 17.5011H18.0542C18.5704 17.5011 19.0653 17.286 19.4303 16.9031C19.7953 16.5202 20.0003 16.0009 20.0003 15.4593V4.54178C20.0003 4.00027 19.7953 3.48093 19.4303 3.09802C19.0653 2.71512 18.5704 2.5 18.0542 2.5ZM9.0269 4.05585H10.973C10.9966 4.05679 11.0195 4.06489 11.0389 4.07917C11.0583 4.09345 11.0733 4.11331 11.0821 4.13634V5.4702H8.95554V4.19736C8.94747 4.16867 8.95042 4.1378 8.96375 4.11136C8.97709 4.08492 8.99975 4.06499 9.0269 4.05585ZM3.91594 15.9232C3.88025 15.9232 3.82495 15.943 3.78855 15.943H1.96882C1.85963 15.943 1.8054 15.9232 1.8054 15.7839V14.5302H3.91522L3.91594 15.9232ZM3.89774 5.48892H1.93313C1.9078 5.49149 1.88243 5.4843 1.86177 5.4687V4.13634C1.87997 4.09629 1.91636 4.0566 1.95276 4.0566H3.86277C3.91736 4.03676 3.95376 4.07644 3.97196 4.13634V4.17603C3.99015 4.57435 3.99015 4.97267 3.99015 5.37062C3.97053 5.43014 3.95233 5.46983 3.89774 5.49004V5.48892ZM7.46264 15.9232C7.40805 15.9232 7.37166 15.943 7.33526 15.943H5.51552C5.44416 15.9629 5.3885 15.9232 5.3521 15.8434V14.5103H7.46193L7.46264 15.9232ZM7.46264 5.50876H5.53586C5.48127 5.50876 5.44523 5.4687 5.40884 5.42902V4.09591H7.37308C7.44445 4.07607 7.50046 4.11575 7.53686 4.19549V5.3504C7.54453 5.3819 7.54128 5.41524 7.52769 5.44445C7.51409 5.47367 7.49104 5.49686 7.46264 5.50988V5.50876ZM11.0093 15.9232C10.9548 15.9232 10.9184 15.943 10.8638 15.943H9.04403C8.93485 15.943 8.89845 15.9232 8.89845 15.7839V14.6496C8.89671 14.6024 8.90287 14.5553 8.91665 14.5103H11.0083L11.0093 15.9232ZM11.3961 10.5683L9.09827 12.0568C8.63869 12.3712 8.25905 12.1406 8.25905 11.5746V8.42992C8.25905 7.84292 8.63869 7.63327 9.09827 7.94774L11.3961 9.43621C11.8557 9.7518 11.8557 10.2538 11.3961 10.5683ZM14.5575 15.8648C14.5393 15.9045 14.5029 15.9441 14.4665 15.9441H12.5397C12.504 15.9441 12.4684 15.9045 12.4487 15.8648V14.5305H14.5575V15.8648ZM14.6485 4.19549C14.6128 4.59382 14.6303 4.9723 14.6303 5.3504C14.6303 5.43014 14.6303 5.49004 14.5393 5.49004H12.5372V4.05623H14.5197C14.533 4.05243 14.547 4.05151 14.5608 4.05351C14.5745 4.05551 14.5877 4.0604 14.5996 4.06788C14.6115 4.07536 14.6218 4.08527 14.63 4.09704C14.6381 4.1088 14.6439 4.12217 14.647 4.13634L14.6485 4.19549ZM18.086 15.9243H15.9929V14.5305H18.0846L18.086 15.9243ZM18.1955 4.25539C18.1599 4.61366 18.177 4.99214 18.177 5.37025C18.177 5.44999 18.1591 5.50988 18.0678 5.50988H16.141C16.1157 5.51236 16.0904 5.50533 16.0696 5.49004V4.07607H18.0339C18.1053 4.05623 18.1613 4.09591 18.1977 4.17565L18.1955 4.25539Z"
										fill="#6390C3"
									/>
								</g>
								<defs>
									<clipPath id="clip0_16570_9419">
										<rect
											width="20"
											height="15"
											fill="white"
											transform="translate(0 2.5)"
										/>
									</clipPath>
								</defs>
							</svg>
						</div>
						<div>Số lượng video</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.goal_media_stats.video_count }}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">Học phí</div>
			<div
				class="
					grid grid-cols-2
					items-start
					md-down:grid-cols-1
					mt-2
					gap-4
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M10 20C11.3807 20 12.5 18.8807 12.5 17.5H7.5C7.5 18.8807 8.61929 20 10 20Z"
									fill="#E68D7B"
								/>
								<path
									d="M11.2439 1.37379C11.248 1.33307 11.25 1.29177 11.25 1.25C11.25 0.559644 10.6904 0 10 0C9.30964 0 8.75 0.559644 8.75 1.25C8.75 1.29178 8.75205 1.33308 8.75605 1.3738C5.90025 1.95056 3.75003 4.47417 3.75003 7.5C3.75003 8.87201 3.125 15 1.25 16.25H18.75C16.875 15 16.25 8.87201 16.25 7.5C16.25 4.47415 14.0998 1.95053 11.2439 1.37379Z"
									fill="#E68D7B"
								/>
							</svg>
						</div>
						<div>Thông báo học phí</div>
					</div>
					<div class="text-xl font-bold mt-4 text-neutral-600">
						<span v-if="data.tuition_stats.notice_sent_count">
							{{
								`Đã gửi lần ${
									data.tuition_stats.notice_sent_count || 0
								}`
							}}
							<span
								v-if="data.tuition_stats.lastest_notice_sent_at"
								>{{
									`vào ${$filters.formatDate(
										data.tuition_stats
											.lastest_notice_sent_at
									)}`
								}}</span
							>
						</span>
						<span v-else>Chưa gửi</span>
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-start justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M13.8194 5H6.18089C6.18089 5 0.833313 9.73633 0.833313 15.2637C0.833313 18.4206 3.13294 20 4.65259 20H15.3474C16.8734 20 19.1666 18.4204 19.1666 15.2637C19.1666 9.73633 13.8191 5 13.8191 5H13.8194ZM10.7632 15.9725V17.2366H9.23713L9.23699 15.9767C8.11226 15.7606 7.40574 15.0433 7.35561 14.0018H8.67893C8.74368 14.5484 9.27682 14.9007 10.0482 14.9007C10.7589 14.9007 11.2628 14.5442 11.2628 14.0365C11.2628 13.6043 10.9367 13.3579 10.134 13.1722L9.28309 12.9843C8.09143 12.7271 7.50609 12.0854 7.50609 11.0547C7.50609 10.0241 8.17091 9.28068 9.2287 9.03651V7.76366H10.7547V9.03848C11.7874 9.27617 12.4753 10.0043 12.5087 10.9831L11.2314 10.9832C11.1667 10.4495 10.6857 10.0931 10.0252 10.0931C9.36462 10.0931 8.88791 10.4215 8.88791 10.9358C8.88791 11.3529 9.19939 11.5841 9.96657 11.7612L10.7547 11.934C12.0696 12.2192 12.6361 12.7983 12.6361 13.855C12.6363 14.985 11.9338 15.7413 10.7632 15.9725L10.7632 15.9725Z"
									fill="#F0BB4F"
								/>
								<path
									d="M13.474 0.830102H11.5536C11.1569 0.3017 10.5924 0 10.0001 0C9.40778 0 8.8433 0.301716 8.44659 0.830102H6.52621C6.2965 0.831217 6.08217 0.968534 5.95325 1.19681C5.82433 1.4251 5.79754 1.71518 5.88163 1.97198L6.5262 4.16667H13.4738L14.1183 1.97198C14.2024 1.71519 14.1756 1.42511 14.0467 1.19681C13.9178 0.968521 13.7035 0.831219 13.4737 0.830102H13.474Z"
									fill="#F0BB4F"
								/>
							</svg>
						</div>
						<div>Đóng học phí</div>
					</div>
					<div class="text-xl font-bold mt-4 text-neutral-600">
						{{ data.tuition_stats.paid ? 'Đã đóng' : 'Chưa đóng' }}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">
				Phụ huynh xem báo cáo
			</div>
			<div
				class="
					grid grid-cols-3
					items-start
					md-down:grid-cols-1
					mt-2
					gap-4
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
									fill="#41BEAD"
								/>
							</svg>
						</div>
						<div>Báo cáo ngày</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.report_read_stats.daily_report_total_view }} /
						{{ data.report_read_stats.daily_report_total_received }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
									fill="#41BEAD"
								/>
							</svg>
						</div>
						<div>Báo cáo tuần</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.report_read_stats.weekly_report_total_view }} /
						{{
							data.report_read_stats.weekly_report_total_received
						}}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
									fill="#41BEAD"
								/>
							</svg>
						</div>
						<div>Báo cáo tháng</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.report_read_stats.monthly_report_total_view }} /
						{{
							data.report_read_stats.monthly_report_total_received
						}}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">
				Trị liệu viên làm báo cáo
			</div>
			<div
				class="
					grid grid-cols-3
					items-start
					md-down:grid-cols-1
					mt-2
					gap-4
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
									fill="#41BEAD"
								/>
							</svg>
						</div>
						<div>Báo cáo ngày</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{
							data?.completed_report_stats
								?.completed_lesson_report_count
						}}
						/
						{{
							data?.completed_report_stats
								?.total_lesson_report_count
						}}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
									fill="#41BEAD"
								/>
							</svg>
						</div>
						<div>Báo cáo tuần</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{
							data?.completed_report_stats
								?.completed_weekly_report_count
						}}
						/
						{{
							data?.completed_report_stats
								?.total_weekly_report_report_count
						}}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
									fill="#41BEAD"
								/>
							</svg>
						</div>
						<div>Báo cáo tháng</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{
							data?.completed_report_stats
								?.completed_monthly_report_count
						}}
						/
						{{
							data?.completed_report_stats
								?.total_monthly_report_report_count
						}}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10">
			<div class="font-semibold text-neutral-500">Kế hoạch can thiệp</div>
			<div
				class="
					grid grid-cols-3
					items-start
					md-down:grid-cols-1
					mt-2
					gap-4
				"
			>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Kế hoạch can thiệp</div>
					</div>
					<div
						class="
							text-xl
							font-bold
							mt-4
							text-green-500
							cursor-pointer
						"
						@click="$router.push(`/plans/${studentId}`)"
					>
						Kế hoạch can thiệp {{ data.plan_stats.plan_order }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/abc.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Lĩnh vực đã học / dự kiến</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.plan_stats.skills_count || 0 }} /
						{{ data.plan_stats.total_skills_count || 0 }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Mục tiêu đã học / dự kiến</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.plan_stats.goals_count || 0 }} /
						{{ data.plan_stats.total_goals_count || 0 }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>MT đã hoàn thành</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.plan_stats.completed || 0 }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Mục tiêu tiếp tục</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.plan_stats.continued || 0 }}
					</div>
				</div>
				<div
					class="
						w-full
						h-full
						text-neutral-500
						px-6
						py-4
						rounded-lg
						bg-white
						shadow
						border-sm
						flex flex-col
						items-start
						justify-between
					"
				>
					<div class="flex items-center justify-start gap-4">
						<div>
							<img
								src="@/assets/images/icons/light.png"
								alt=""
								width="32"
								height="32"
								style="height: 32px"
							/>
						</div>
						<div>Mục tiêu tạm dừng</div>
					</div>
					<div class="text-4xl font-bold mt-4 text-neutral-600">
						{{ data.plan_stats.stopped || 0 }}
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="radarData.length && radarData[0]?.data.length >= 3"
			class="mt-10"
		>
			<div
				class="
					bg-white
					shadow-sm
					rounded-2xl
					overflow-hidden
					mb-10
					pb-5
				"
			>
				<div class="font-semibold text-neutral-500 p-6">
					Biểu đồ mối tương quan giữa kết quả các lĩnh vực trong tháng
				</div>
				<div
					class="
						p-6
						border-t border-orange-50
						md-down:px-0
						overflow-x-auto
						w-full
					"
				>
					<apexchart
						type="radar"
						height="700"
						:options="radarChartOptions"
						:series="radarData"
					></apexchart>
					<div
						class="
							py-4
							flex flex-wrap
							gap-6
							justify-center
							items-center
						"
					>
						<div
							v-for="(c, index) in categories"
							:key="c"
							class="flex items-center flex-nowrap gap-2"
						>
							<div class="font-bold text-lf text-neutral-700">
								{{ index + 1 }}: {{ c }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { $api } from '@/services';

export default {
	name: 'StudentDetailStats',
	props: {
		student: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			date: {
				month: new Date().getMonth(),
				year: new Date().getFullYear(),
			},
			chartOptions2_1: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '54%',
						},
						dataLabels: {
							name: {
								// offsetY: -10,
								show: false,
								color: '#65758B',
								fontWeight: 'normal',
								fontSize: '13px',
							},
							value: {
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
								offsetY: 8,
								offsetX: 8,
							},
						},
					},
				},
				fill: {
					colors: '#6ED0B9',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			chartOptions2_2: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '54%',
						},
						dataLabels: {
							name: {
								// offsetY: -10,
								show: false,
								color: '#65758B',
								fontWeight: 'normal',
								fontSize: '13px',
							},
							value: {
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
								offsetY: 8,
								offsetX: 8,
							},
						},
					},
				},
				fill: {
					colors: '#FFD270',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			chartOptions2_3: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '54%',
						},
						dataLabels: {
							name: {
								// offsetY: -10,
								show: false,
								color: '#65758B',
								fontWeight: 'normal',
								fontSize: '13px',
							},
							value: {
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
								offsetY: 8,
								offsetX: 8,
							},
						},
					},
				},
				fill: {
					colors: '#DA8F8F',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			data: {
				assessment_stats: {
					average_cooperation_scale_in_percent: 0,
					average_emotion_scale_in_percent: 0,
					average_result_in_percent: 0,
					compare_last_average_cooperation_scale: null,
					compare_last_average_emotion_scale: null,
					compare_last_average_result: null,
				},
				goal_media_stats: {
					image_count: 0,
					video_count: 0,
				},
				plan_stats: {
					completed: 0,
					continued: 0,
					goals_count: 0,
					plan_id: 0,
					plan_order: 0,
					skills_count: 0,
					stopped: 0,
					total_goals_count: 0,
					total_skills_count: 0,
				},
				report_read_stats: {
					daily_report_total_received: 0,
					daily_report_total_view: 0,
					monthly_report_total_received: 0,
					monthly_report_total_view: 0,
					weekly_report_total_received: 0,
					weekly_report_total_view: 0,
				},
				tuition_stats: {
					lastest_notice_sent_at: null,
					notice_sent_count: null,
					paid: false,
				},
			},
			radarData: [],
			categories: [],
			radarChartOptions: {
				chart: {
					id: 'radarChart',
					type: 'radar',
				},
				title: {
					show: false,
				},
				stroke: {
					width: 0,
				},
				fill: {
					opacity: 0.2,
					colors: ['#65A30D'],
				},
				markers: {
					size: 5,
					hover: {
						size: 10,
					},
					colors: ['#65A30D'],
				},
				plotOptions: {
					bar: {
						columnWidth: '20%',
					},
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val + '%';
					},
					style: {
						fontFamily: 'Gilrory',
						fontSize: '20px',
						fontWeight: 'bold',
						colors: ['#344256'],
					},
					background: {
						enabled: false,
					},
				},
				yaxis: {
					show: false,
					logBase: 100,
					tickAmount: 10,
					min: 0,
					max: 100,
					labels: {
						show: false,
					},
				},
				xaxis: {
					categories: [],
					labels: {
						show: true,
						style: {
							fontFamily: 'Gilrory',
							fontSize: '24px',
							fontWeight: 'bold',
							colors: Array(1000).fill('#344256'),
						},
						formatter: function (val, index) {
							return index?.dataPointIndex + 1;
						},
					},
				},
				tooltip: {
					x: {
						show: true,
						formatter: function (val, object) {
							return `${object?.dataPointIndex + 1}: ${val}`;
						},
						title: {
							formatter: (seriesName) => seriesName,
						},
					},
					y: {
						show: true,
						formatter: function (val) {
							return val + '%';
						},
						title: {
							title: {
								formatter: (seriesName) => seriesName + ':',
							},
						},
					},
				},
			},
		};
	},

	created() {
		this.fetchStudentStats();
	},

	watch: {
		date: {
			deep: true,
			handler(value) {
				if (value) {
					this.fetchStudentStats();
				}
			},
		},
	},

	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		dateTitle() {
			return dayjs(new Date(this.date.year, this.date.month, 1)).format(
				'MM/YYYY'
			);
		},

		studentId() {
			return this.$route.params.id;
		},

		datePayload() {
			return dayjs(new Date(this.date.year, this.date.month, 1)).format(
				'YYYY-MM-DD'
			);
		},

		oldPayload() {
			return {
				'x-cross': this.$route.query.org_id,
			};
		},

		is_old_data() {
			return this.$route.query.is_old_data === 'true';
		},
	},

	methods: {
		prevDay() {
			const da = dayjs(new Date(this.date.year, this.date.month, 1))
				.subtract(1, 'month')
				.toDate();
			this.date = {
				month: da.getMonth(),
				year: da.getFullYear(),
			};
		},

		nextDay() {
			const da = dayjs(new Date(this.date.year, this.date.month, 1))
				.add(1, 'month')
				.toDate();
			this.date = {
				month: da.getMonth(),
				year: da.getFullYear(),
			};
		},

		async fetchStudentStats() {
			try {
				const { data } = this.isAdmin
					? await $api.student.fetchDashboard(
							this.studentId,
							{
								date: this.datePayload,
							},
							this.is_old_data ? this.oldPayload : null
					  )
					: await $api.student.fetchDashboardTeacher(
							this.studentId,
							{
								date: this.datePayload,
							},
							this.is_old_data ? this.oldPayload : null
					  );
				this.data = data;
				this.radarData = [
					{
						name: 'Kết quả',
						data: data?.skills.map((skill) => {
							return skill?.complete_percent;
						}),
					},
				];
				this.radarChartOptions.xaxis.categories = data?.skills.map(
					(skill) => {
						return skill?.name;
					}
				);
				this.categories = data?.skills.map((skill) => {
					return skill?.name;
				});
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
					type: 'danger',
				});
			}
		},
	},
};
</script>
<style lang="scss">
.input-date-dashboard {
	font-family: 'Gilrory', sans-serif !important;
}
</style>
